export function goalElapsedMs(goal, now = Date.now()) {
  const saved = Math.max(0, Number(goal?.elapsedMs) || 0);
  if (goal?.status !== 'active') return saved;
  const since = Date.parse(goal.activeSince || goal.createdAt);
  return saved + (Number.isFinite(since) ? Math.max(0, now - since) : 0);
}

export function formatGoalElapsed(milliseconds) {
  const seconds = Math.floor(Math.max(0, milliseconds) / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}
